import {Assets, Container, Graphics, Sprite, Texture} from "pixi.js";

import * as PIXI from "pixi.js";
import { TextDrawable } from "./text.pixi";
import { ImageDrawable } from "./image.pixi";
import { PixiServices } from "../pixi-service";
import moment from "moment";
import {FilesService} from "../../../../services/files/files.service";
import {BlueprintContext} from "../../../world/cyanprints/i-blueprint-context";
import {PixiObject} from "../primitives/pixi-object";
import {Subscription} from "rxjs";
import {selectUserById} from "../../../../state/users/users.selector";
import {User} from "../../../../auth/primitives/user";
import {DRect} from "../../../primitives/drawable-rect";
import {Rect, RectConstructor} from "../../../primitives/rect";
import {interfaceActions} from "../../../../state/interface/interface.actions";

export function headerStyle(): PIXI.TextStyle {
  const fontSize = 16;
  const textStyle = new PIXI.TextStyle({
    fontFamily: ["inter"],
    fontSize: fontSize,
    fontWeight: "normal",
    fill: "#8d8d8d",
    wordWrap: true,
    wordWrapWidth: 315,
    breakWords: true,
    align: "left",
  });
  return textStyle;
}

export function recentStyle(): PIXI.TextStyle {
  const fontSize = 12;
  const textStyle = new PIXI.TextStyle({
    fontFamily: ["inter"],
    fontSize: fontSize,
    fontWeight: "normal",
    fill: "#6f6f6f",
    wordWrap: true,
    wordWrapWidth: 315,
    breakWords: true,
    align: "left",
  });
  return textStyle;
}


export class ProfileDrawable extends PixiObject {
  __debug = false;

  fileService: FilesService;

  profileImage: ImageDrawable;
  profileImagePlaceholder: Graphics;
  profileImageHolder: Container;
  profileNameText: TextDrawable;
  creationDateText: TextDrawable;

  blueprintContext: BlueprintContext;

  isMe: boolean;

  subscriptions: Subscription[] = []

  constructor(config: {
    blueprintContext: BlueprintContext;
    isMe: boolean
  }) {
    super({ id: "profile-drawable" });
    this.blueprintContext = config.blueprintContext;
    this.isMe = config.isMe;
    this.profileImageHolder = new Container();
    this.sprite.addChild(this.profileImageHolder);
    this.createProfileImagePlaceholder()
    this.fileService = config.blueprintContext.networkServices.fileService
    this.subscriptions.push(config.blueprintContext.stateServices.store.select(
            selectUserById(config.blueprintContext.entity.ownerId)
      ).subscribe(async user => {
        if (!user) return
        if (this.profileImage) {
          this.profileImage.destroy()
        }
        this.profileImage = new ImageDrawable({
          fitInSquareSize: 30,
          fileId: user.profile_image_file_id,
          blueprintContext: config.blueprintContext,
          borderRadius: 100
        })
        this.touchPrimitive.showPointerCursor = true
        this.profileImage.sprite.x = 0;
        this.profileImage.sprite.y = 0;
        await this.profileImage.createOrUpdate({})
        this.addChild(this.profileImage)
        // this.profileImageHolder.addChild(this.profileImage.sprite)
        this.profileImagePlaceholder.destroy()
        await this.updateProfile(user, config.blueprintContext.entity.creationDate)
    }))
    this.setupInteractions()
  }

  createProfileImagePlaceholder() {
      if (this.profileImagePlaceholder) {
        this.profileImagePlaceholder.destroy();
      }
      this.profileImagePlaceholder = new Graphics({});
      const rect = new DRect({
        left: 0,
        top: 0,
        right: 250,
        bottom: 30,
        roundness: 5,
        colour: this.niceColourMaker(),
      });
      rect.render(this.profileImagePlaceholder);
      this.profileImageHolder.addChild(this.profileImagePlaceholder);
  }

  setupInteractions() {
    this.touchPrimitive.onPressed( (pt) => {
      this.sprite.alpha = 0.5;
      this.requestRender()
      return true; // Stop propagation
    });
    this.touchPrimitive.onReleased( (pt) => {
      this.sprite.alpha = 1;
      this.requestRender()
      this.blueprintContext.stateServices.store.dispatch(interfaceActions.openContextMenu())
      this.blueprintContext.stateServices.router.navigate(
          [{outlets: {'context-menu': "context-profile"}}],
          {
            queryParams: {
              userId: this.blueprintContext.entity.ownerId,
              posX: pt.pos.x - 150,
              posY: pt.pos.y
            },
            queryParamsHandling: 'merge' // optional but common
          })
      return true; // Stop propagation
    });
  }

  niceColourMaker() {
    const r = 0.1 + (Math.random() * 0.05 - 0.02);
    const g = 0.1 + (Math.random() * 0.05 - 0.02);
    const b = 0.1 + (Math.random() * 0.05 - 0.02);
    return [r, g, b, 1];
  }

  async updateProfile(user: User, recent: Date | string) {
    const creationDateString =
        this.blueprintContext.renderServices
            .textUtilsService.fromNowToString(recent)
    if (!this.profileNameText) {
      this.makeProfileText(user.display_name);
      this.sprite.addChild(this.profileNameText.sprite);
    }
    if (!this.creationDateText) {
      this.makeCreationDateText(creationDateString);
      this.sprite.addChild(this.creationDateText.sprite);
    }
    if (this.profileNameText && this.profileNameText.text !== user.display_name) {
      this.profileNameText.text = user.display_name;
    }
    if (
      this.creationDateText &&
      this.creationDateText.text !== creationDateString
    ) {
      this.creationDateText.text = creationDateString;
    }
    // const headerTop =
    //   (40 -
    //     (this.profileNameText.sprite.height +
    //       this.creationDateText.sprite.height)) /
    //   2;
    this.profileNameText.sprite.y = 4;
    this.profileNameText.sprite.x = 39;
    this.creationDateText.sprite.x = this.profileNameText.right + 9;
    this.creationDateText.sprite.y = 8;
  }

  isOlderThanHours(datep: Date | string, hours: number): boolean {
    let date: Date = datep as any;
    if (typeof datep === typeof "123") {
      date = new Date(datep);
    }
    const now = new Date();
    const oneDayAgo = now.getTime() - hours * 60 * 60 * 1000; // 24 hours in ms
    return date.getTime() < oneDayAgo;
  }

  isWithinPastWeek(date: Date) {
    const now = new Date();
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
    const diff = now.getTime() - date.getTime();

    // Is the difference positive (in the past) and less than 7 days?
    return diff <= sevenDaysInMs;
  }

  isFromPreviousYear(date: Date) {
    const currentYear = new Date().getFullYear();
    const targetYear = date.getFullYear();
    return targetYear === currentYear - 1;
  }

  isWithinPastTwoHours(date: Date) {
    const now = new Date();
    const twoHoursInMs = 2 * 60 * 60 * 1000;
    const diff = now.getTime() - date.getTime();

    return diff <= twoHoursInMs;
  }

  makeCreationDateText(creationDate: string) {
    const recentTextStyle = recentStyle();
    this.creationDateText = new TextDrawable({
      margin: {  },
      text: creationDate,
      style: recentTextStyle,
    });
  }

  makeProfileText(username: string) {
    const headerTextStyle = headerStyle();
    this.profileNameText = new TextDrawable({
      margin: {  },
      text: username,
      style: headerTextStyle,
    });
  }
}
